module.exports = __webpack_public_path__ + "img/piuJhapa.077decea.png";